<!-- Superposición de fondo -->
<div class="modal-overlay w-2/3" (click)="closeSparePartModal()"></div>

<!-- Contenedor del modal -->
<div class="modal-box max-w-4xl my-8">
  <div #modalContent class="modal-content p-6">
    <span class="close-button" (click)="closeSparePartModal()">&times;</span>
    <div class="flex justify-between items-center pr-8 mb-4">
      <h3 class="font-bold text-lg">{{ duplicateMode ? 'Duplicar Repuesto (con cambios)' : 'Editar Repuesto' }}</h3>
      <button type="button" class="btn btn-sm" (click)="toggleAldanaForm()">Aldana</button>
    </div>

    <!-- Mensajes de éxito y error -->
    <div *ngIf="showSuccessMessage" class="alert alert-success mb-4">
      <i class="fas fa-check-circle mr-2"></i>
      {{ successMessage }}
    </div>

    <div *ngIf="showErrorMessage" class="alert alert-error mb-4">
      <i class="fas fa-exclamation-circle mr-2"></i>
      {{ errorMessage }}
    </div>

    <div *ngIf="showLowSaleRatioConfirmModal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[80]">
      <div class="bg-white rounded-lg shadow-lg w-full max-w-2xl mx-4" (click)="$event.stopPropagation()">
        <div class="p-4 border-b flex justify-between items-center">
          <h2 class="text-xl font-bold text-red-700">Confirmar guardado de repuesto duplicado</h2>
          <button type="button" (click)="cancelLowSaleRatioAndContinueEditing()" class="text-gray-500 hover:text-gray-700">
            <i class="fas fa-times"></i>
          </button>
        </div>
        <div class="p-4">
          <p class="text-gray-700 mb-2">
            Este repuesto tiene <strong>V.Venta / P.Unitario menor o igual a 11</strong>.
          </p>
          <p class="text-gray-700 mb-3">¿Deseas duplicarlo de todas formas?</p>
          <div class="max-h-52 overflow-y-auto border border-red-200 bg-red-50 rounded p-3">
            <p class="text-sm font-semibold text-red-800 mb-2">Repuesto que no cumple:</p>
            <ul class="list-disc list-inside text-sm text-red-700 space-y-1">
              <li *ngFor="let label of lowSaleRatioViolationLabels">{{ label }}</li>
            </ul>
          </div>
        </div>
        <div class="p-4 border-t flex justify-end gap-2">
          <button type="button" (click)="cancelLowSaleRatioAndContinueEditing()"
            class="px-4 py-2 bg-gray-200 text-gray-800 rounded hover:bg-gray-300">
            Cancelar
          </button>
          <button type="button" (click)="confirmLowSaleRatioAndContinue()"
            class="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700">
            Guardar igual
          </button>
        </div>
      </div>
    </div>

    <form>
      <div *ngIf="selectedSparePart">
        <div *ngIf="showAldanaForm" class="border rounded-md p-3 mb-4 bg-gray-50">
          <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
            <div class="flex flex-col">
              <label class="text-sm text-gray-600">Interno:</label>
              <input type="text" [(ngModel)]="selectedSparePart.interno" name="interno" class="p-2 border rounded w-full">
            </div>
            <div class="flex flex-col">
              <label class="text-sm text-gray-600">Externo:</label>
              <input type="text" [(ngModel)]="selectedSparePart.externo" name="externo" class="p-2 border rounded w-full">
            </div>
            <div class="flex flex-col">
              <label class="text-sm text-gray-600">Fecha de comunicado:</label>
              <input type="date" [(ngModel)]="aldanaFechaComunicadoInput" name="fechaDeComunicado"
                class="p-2 border rounded w-full">
            </div>
            <div class="flex flex-col">
              <label class="text-sm text-gray-600 mb-2">Color:</label>
              <div class="flex flex-wrap gap-2">
                <button *ngFor="let color of aldanaColorOptions"
                  type="button"
                  class="w-8 h-8 border rounded"
                  [title]="color.name"
                  [ngStyle]="{
                    'background-color': color.hex,
                    'border-color': selectedSparePart.color === color.value ? '#2563eb' : '#9ca3af',
                    'box-shadow': selectedSparePart.color === color.value ? '0 0 0 2px rgba(37,99,235,0.35)' : 'none'
                  }"
                  (click)="selectAldanaColor(color.value)">
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
          <!-- Identificación / Nombre -->
          <div class="flex flex-col">
            <label class="text-sm text-gray-600">Nombre del Repuesto (General):</label>
            <input type="text" [(ngModel)]="selectedSparePart.sparePartName" name="sparePartName" class="p-2 border rounded w-full">
          </div>

          <div class="flex flex-col">
            <label class="text-sm text-gray-600">🇪🇸 Nombre en Español (Para etiquetas):</label>
            <input type="text" [(ngModel)]="selectedSparePart.sparePartNameEs" name="sparePartNameEs" class="p-2 border rounded w-full"
              placeholder="Nombre en español">
          </div>

          <div class="flex flex-col">
            <label class="text-sm text-gray-600">🇧🇷 Nombre en Portugués (Para Excel):</label>
            <input type="text" [(ngModel)]="selectedSparePart.sparePartNamePt" name="sparePartNamePt" class="p-2 border rounded w-full"
              placeholder="Nome em português">
          </div>

          <div class="flex flex-col">
            <label class="text-sm text-gray-600">Código del Producto:</label>
            <input type="text" [(ngModel)]="selectedSparePart.productCode" name="productCode" class="p-2 border rounded w-full">
          </div>

          <div class="flex flex-col">
            <label class="text-sm text-gray-600">Proveedor del repuesto:</label>
            <select [(ngModel)]="selectedSparePart.providerName" name="providerName" class="p-2 border rounded w-full">
              <option *ngFor="let providerName of getProviderOptions(selectedSparePart.providerName)" [value]="providerName">
                {{ providerName }}
              </option>
            </select>
          </div>

          <!-- Estado y seguimiento -->
          <div class="flex flex-col">
            <label class="text-sm text-gray-600">Estado del Producto:</label>
            <select [(ngModel)]="selectedSparePart.productStatus" name="status" class="p-2 border rounded w-full">
              <option *ngFor="let status of sparePartStatusOptions" [value]="status">
                {{ status }}
              </option>
            </select>
          </div>

          <div class="flex flex-col p-2 rounded reception-status-field"
            [ngClass]="getReceptionStatusFieldClass(selectedSparePart.receptionStatus)">
            <label class="text-sm font-medium">Recepción Física:</label>
            <select [(ngModel)]="selectedSparePart.receptionStatus" name="receptionStatus" class="p-2 border rounded w-full">
              <option *ngFor="let opt of sparePartReceptionStatusOptions" [value]="opt">
                {{ opt === '' ? 'PENDIENTE' : opt }}
              </option>
            </select>
            <small class="text-gray-500 text-xs mt-1">Confirmación cuando el repuesto llega físicamente (o incidencia).</small>
          </div>

          <div class="flex flex-col">
            <label class="text-sm text-gray-600" for="shippingStatus">Envio:</label>
            <select [(ngModel)]="selectedSparePart.shippingStatus" name="shippingStatus" class="p-2 border rounded w-full">
              <option *ngFor="let shippingOption of shippingSparePartOptions" [value]="shippingOption">
                {{ shippingOption }}
              </option>
            </select>
          </div>

          <div class="flex flex-col">
            <label class="text-sm text-gray-600">Día y hora de llegada:</label>
            <input type="datetime-local" [(ngModel)]="selectedSparePartPhysicalArrivalDateTime" name="arrivalDate"
              class="p-2 border rounded w-full">
          </div>

          <div class="flex flex-col">
            <label class="text-sm text-gray-600">Orden Nueva:</label>
            <input type="text" [(ngModel)]="selectedSparePart.newOrderNumber" name="newOrderNumber" class="p-2 border rounded w-full" placeholder="Opcional">
          </div>

          <div class="flex flex-col">
            <label class="text-sm text-gray-600">Fecha de Llegada Esperada:</label>
            <input type="date" [(ngModel)]="selectedSparePartArrivalDate" name="expectedArrivalDate"
              class="p-2 border rounded w-full">
          </div>

          <div class="flex flex-col">
            <label class="text-sm text-gray-600">Fecha de Exportación:</label>
            <input type="date" [(ngModel)]="selectedSparePartExportDate" name="fechaExportacion"
              class="p-2 border rounded w-full">
          </div>

          <!-- Cantidad y valores -->
          <div class="flex flex-col">
            <label class="text-sm text-gray-600">Cantidad:</label>
            <input type="text" [(ngModel)]="selectedSparePart.amount" name="amount" class="p-2 border rounded w-full"
              (input)="handleNumericInput($event)">
          </div>

          <div class="flex flex-col">
            <label class="text-sm text-gray-600">Precio Unitario:</label>
            <input type="text" [(ngModel)]="selectedSparePart.unitPrice" name="unitPrice" class="p-2 border rounded w-full"
              (input)="handleNumericInput($event)">
          </div>

          <div class="flex flex-col">
            <label class="text-sm text-gray-600">Valor de Venta:</label>
            <input type="text" [(ngModel)]="selectedSparePart.valorDeVenta" name="valorDeVenta" class="p-2 border rounded w-full"
              (input)="handleNumericInput($event)">
          </div>

          <div class="flex flex-col">
            <label class="text-sm text-gray-600">País:</label>
            <input type="text" [(ngModel)]="selectedSparePart.country" name="country" class="p-2 border rounded w-full">
          </div>

          <div class="flex flex-col">
            <label class="text-sm text-gray-600">Peso Neto:</label>
            <input type="text" [(ngModel)]="selectedSparePart.netWheight" name="netWheight" class="p-2 border rounded w-full"
              (input)="handleNumericInput($event)">
          </div>

          <div class="flex flex-col">
            <label class="text-sm text-gray-600">Peso Bruto:</label>
            <input type="text" [(ngModel)]="selectedSparePart.grossWheight" name="grossWheight" class="p-2 border rounded w-full"
              (input)="handleNumericInput($event)">
          </div>

          <div class="flex flex-col col-span-1 md:col-span-2">
            <label class="text-sm text-gray-600">Nota Fiscal:</label>
            <input type="text" [(ngModel)]="selectedSparePart.taxNote" name="taxNote" class="p-2 border rounded w-full">
          </div>

          <!-- Checks juntos -->
          <div class="flex flex-col col-span-1 md:col-span-2">
            <label class="text-sm text-gray-600">Checks:</label>
            <div class="flex flex-wrap gap-x-6 gap-y-2 mt-2">
              <label class="inline-flex items-center">
                <input type="checkbox" [(ngModel)]="selectedSparePart.recompra" name="recompra" class="mr-2">
                <span class="text-sm text-gray-700">Recompra</span>
              </label>
              <span class="inline-flex items-center gap-2">
                <label class="inline-flex items-center">
                  <input type="checkbox" [(ngModel)]="selectedSparePart.isFant" name="isFant" class="mr-2" (ngModelChange)="onFantCheckboxChanged($event)">
                  <span class="text-sm text-gray-700">FANT</span>
                </label>
                <span class="inline-flex items-center gap-1" *ngIf="selectedSparePart.isFant">
                  <button type="button" title="Puede esperar" (click)="setFantUrgency('green')"
                    class="w-4 h-4 rounded-full bg-green-500 border-2"
                    [class.border-gray-900]="selectedSparePart.fantUrgency === 'green'"
                    [class.border-transparent]="selectedSparePart.fantUrgency !== 'green'"
                    [class.ring-2]="selectedSparePart.fantUrgency === 'green'"
                    [class.ring-green-800]="selectedSparePart.fantUrgency === 'green'"></button>
                  <button type="button" title="Atención" (click)="setFantUrgency('yellow')"
                    class="w-4 h-4 rounded-full bg-yellow-400 border-2"
                    [class.border-gray-900]="selectedSparePart.fantUrgency === 'yellow'"
                    [class.border-transparent]="selectedSparePart.fantUrgency !== 'yellow'"
                    [class.ring-2]="selectedSparePart.fantUrgency === 'yellow'"
                    [class.ring-yellow-700]="selectedSparePart.fantUrgency === 'yellow'"></button>
                  <button type="button" title="Urgente" (click)="setFantUrgency('red')"
                    class="w-4 h-4 rounded-full bg-red-500 border-2"
                    [class.border-gray-900]="selectedSparePart.fantUrgency === 'red'"
                    [class.border-transparent]="selectedSparePart.fantUrgency !== 'red'"
                    [class.ring-2]="selectedSparePart.fantUrgency === 'red'"
                    [class.ring-red-800]="selectedSparePart.fantUrgency === 'red'"></button>
                </span>
              </span>
              <label class="inline-flex items-center">
                <input type="checkbox" [(ngModel)]="selectedSparePart.control" name="control" class="mr-2">
                <span class="text-sm text-gray-700">Control</span>
              </label>
              <label class="inline-flex items-center">
                <input type="checkbox" [(ngModel)]="selectedSparePart.anulado" name="anulado" class="mr-2">
                <span class="text-sm text-gray-700">Anulado</span>
              </label>
              <label class="inline-flex items-center">
                <input type="checkbox" [(ngModel)]="selectedSparePart.trello" name="trello" class="mr-2">
                <span class="text-sm text-gray-700">Trello</span>
              </label>
              <label class="inline-flex items-center">
                <input type="checkbox" [(ngModel)]="selectedSparePart.devZureo" name="devZureo" class="mr-2">
                <span class="text-sm text-gray-700">DevZureo</span>
              </label>
              <label class="inline-flex items-center">
                <input type="checkbox" [(ngModel)]="selectedSparePart.entradaSage" name="entradaSage" class="mr-2">
                <span class="text-sm text-gray-700">Entrada Sage</span>
              </label>
              <label class="inline-flex items-center">
                <input type="checkbox" [(ngModel)]="selectedSparePart.controleSeba" name="controleSeba" class="mr-2">
                <span class="text-sm text-gray-700">Controle Seba</span>
              </label>
              <label class="inline-flex items-center">
                <input type="checkbox" [(ngModel)]="selectedSparePart.okAnulacao" name="okAnulacao" class="mr-2">
                <span class="text-sm text-gray-700">Ok Anulação</span>
              </label>
              <label class="inline-flex items-center">
                <input type="checkbox" [(ngModel)]="selectedSparePart.facturado" name="facturado" class="mr-2">
                <span class="text-sm text-gray-700">Facturado</span>
              </label>
            </div>
          </div>

          <!-- Paquete / Exportación -->
          <div class="flex flex-col">
            <label class="text-sm text-gray-600">Número de Paquete:</label>
            <input type="text" [(ngModel)]="selectedSparePart.packageNumber" name="packageNumber" class="p-2 border rounded w-full bg-gray-100"
              placeholder="Asignado automáticamente al generar etiquetas" readonly>
          </div>

          <div class="flex flex-col">
            <label class="text-sm text-gray-600">
              <i class="fas fa-shipping-fast mr-2 text-blue-500"></i>
              Número de Exportación:
            </label>
            <input type="text" [(ngModel)]="selectedSparePart.exportNumber" name="exportNumber"
              class="p-2 border rounded w-full focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              placeholder="Ej: EXP-001, ABC123, 001">
            <small class="text-gray-500 text-xs mt-1">
              <i class="fas fa-info-circle mr-1"></i>
              Cada repuesto puede tener su propio número de exportación
            </small>
          </div>

          <div class="flex flex-col col-span-1 md:col-span-2">
            <label class="text-sm text-gray-600">Empaquetador:</label>
            <div class="p-2 border rounded w-full bg-gray-100 text-gray-700">
              {{ selectedSparePart.packager || '—' }}
            </div>
            <small class="text-gray-500 text-xs mt-1">Se asigna al confirmar empaquetado; no es editable desde aquí.</small>
          </div>

          <div class="flex flex-col col-span-1 md:col-span-2">
            <label class="text-sm text-gray-600">Última exportación (camión):</label>
            <div class="p-2 border rounded w-full bg-gray-100 text-gray-700">
              {{ selectedSparePart.lastExportedAt ? (selectedSparePart.lastExportedAt | date:'dd/MM/yyyy HH:mm') : '—' }}
            </div>
            <small class="text-gray-500 text-xs mt-1">Fecha en que pasó a EXPORTADO (carga al camión). Se conserva al cambiar de estado.</small>
          </div>

          <!-- Comentarios -->
          <div class="flex flex-col col-span-1 md:col-span-2">
            <label class="text-sm text-gray-600">Comentarios:</label>
            <textarea [(ngModel)]="selectedSparePart.comments" name="comments" class="p-2 border rounded w-full" rows="3"></textarea>
          </div>

          <div class="flex flex-col col-span-1 md:col-span-2">
            <label class="text-sm text-gray-600">Comentario emergente:</label>
            <textarea [(ngModel)]="selectedSparePart.emergentComment" name="emergentComment" class="p-2 border rounded w-full" rows="2"></textarea>
            <small *ngIf="selectedSparePart.effectiveEmergentComment && !selectedSparePart.emergentComment" class="text-xs text-amber-700 mt-1">
              Heredado de la orden: {{ selectedSparePart.effectiveEmergentComment }}
            </small>
          </div>

          <div class="flex flex-col">
            <label class="text-sm text-gray-600">Estado de devolución:</label>
            <select [(ngModel)]="selectedSparePart.returnStatus" name="returnStatus" class="p-2 border rounded w-full">
              <option value="">Sin definir</option>
              <option *ngFor="let option of returnStatusOptions" [value]="option">{{ option }}</option>
            </select>
          </div>

          <div class="flex flex-col">
            <label class="text-sm text-gray-600">Estado de devolución LOG:</label>
            <select [(ngModel)]="selectedSparePart.returnLogStatus" name="returnLogStatus" class="p-2 border rounded w-full">
              <option value="">Sin definir</option>
              <option *ngFor="let option of returnLogStatusOptions" [value]="option">{{ option }}</option>
            </select>
          </div>

          <div class="flex flex-col">
            <label class="text-sm text-gray-600">Motivo de devolución:</label>
            <select [(ngModel)]="selectedSparePart.returnReason" name="returnReason" class="p-2 border rounded w-full">
              <option value="">Sin definir</option>
              <option *ngFor="let option of returnReasonOptions" [value]="option">{{ option }}</option>
            </select>
          </div>

          <div class="flex flex-col">
            <label class="text-sm text-gray-600">Transportadoras:</label>
            <select [(ngModel)]="selectedSparePart.returnCarrier" name="returnCarrier" class="p-2 border rounded w-full">
              <option value="">Sin definir</option>
              <option *ngFor="let option of returnCarrierOptions" [value]="option">{{ option }}</option>
            </select>
          </div>

          <div class="flex flex-col">
            <label class="text-sm text-gray-600">NFD:</label>
            <input type="text" [(ngModel)]="selectedSparePart.nfd" name="nfd" class="p-2 border rounded w-full">
          </div>

          <div class="flex flex-col">
            <label class="text-sm text-gray-600">Situación ML:</label>
            <select [(ngModel)]="selectedSparePart.mlStatus" name="mlStatus" class="p-2 border rounded w-full">
              <option value="">Sin definir</option>
              <option *ngFor="let option of mlStatusOptions" [value]="option">{{ option }}</option>
            </select>
          </div>

          <div class="flex flex-col">
            <label class="text-sm text-gray-600">Prazo ML:</label>
            <input type="date" [(ngModel)]="selectedSparePartMlDeadline" name="mlDeadline" class="p-2 border rounded w-full">
          </div>

          <div class="flex flex-col">
            <label class="text-sm text-gray-600">FRETE DEV:</label>
            <select [(ngModel)]="selectedSparePart.freteDev" name="freteDev" class="p-2 border rounded w-full">
              <option value="">Sin definir</option>
              <option *ngFor="let option of freteDevOptions" [value]="option">{{ option }}</option>
            </select>
          </div>

          <div class="flex flex-col col-span-1 md:col-span-2">
            <label class="text-sm text-gray-600">Detalles Adicionales:</label>
            <textarea [(ngModel)]="selectedSparePart.returnDetails" name="returnDetails" class="p-2 border rounded w-full" rows="2" placeholder="Detalles de la devolución (opcional)"></textarea>
          </div>

          <!-- Documentación BR -->
          <div class="flex flex-col">
            <label class="text-sm text-gray-600">NCM:</label>
            <input type="text" [(ngModel)]="selectedSparePart.ncm" name="ncm" class="p-2 border rounded w-full">
          </div>

          <div class="flex flex-col">
            <label class="text-sm text-gray-600">Código BR:</label>
            <input type="text" [(ngModel)]="selectedSparePart.codBr" name="codBr" class="p-2 border rounded w-full">
          </div>

          <!-- Poco usado / al fondo -->
          <div class="flex flex-col">
            <label class="text-sm text-gray-600">¿Está Dañado?</label>
            <select [(ngModel)]="selectedSparePart.isDamaged" name="isDamaged" class="p-2 border rounded w-full">
              <option *ngFor="let option of damagedStateOptions" [value]="option.value">{{ option.label }}</option>
            </select>
          </div>

          <div class="flex flex-col">
            <label class="text-sm text-gray-600">Remito:</label>
            <input #shippingReceiptInput id="shippingReceipt" type="text" [(ngModel)]="shippingReceipt" name="shippingReceipt"
              [value]="shippingReceipt" (ngModelChange)="onShippingReceiptChange($event)"
              [attr.data-remito]="selectedSparePart?.shippingReceipt || ''" class="p-2 border rounded w-full">
            <a
              [href]="getDacTrackingUrl(shippingReceipt)"
              target="_blank"
              rel="noopener noreferrer"
              class="text-xs text-blue-600 underline mt-1 break-all"
            >
              Rastrear en DAC
            </a>
          </div>

          <div class="flex flex-col">
            <label class="text-sm text-gray-600">¿Necesita Revisión?</label>
            <select [(ngModel)]="selectedSparePart.needReview" name="needReview" class="p-2 border rounded w-full">
              <option [ngValue]="false">No</option>
              <option [ngValue]="true">Sí</option>
            </select>
          </div>

          <div class="flex flex-col">
            <label class="text-sm text-gray-600">Taller de la orden:</label>
            <div class="p-2 border rounded w-full bg-gray-100 text-gray-700">
              {{ selectedSparePart.workshopName || '-' }}
            </div>
          </div>
          <div class="flex flex-col">
            <label class="text-sm text-gray-600">Enviar:</label>
            <select [(ngModel)]="selectedSparePart.sendYesOrNo" name="sendYesOrNo" class="p-2 border rounded w-full">
              <option value="true">Sí</option>
              <option value="false">No</option>
            </select>
          </div>
        </div>

        <div *ngIf="duplicateMode" class="mb-4">
          <label class="text-sm text-gray-600">Orden destino para el repuesto duplicado:</label>
          <input
            type="text"
            [ngModel]="duplicateTargetOrderNumber"
            (ngModelChange)="onDuplicateTargetOrderNumberChanged($event)"
            name="duplicateTargetOrderNumber"
            class="p-2 border rounded w-full"
            placeholder="Ingrese el número de orden destino (ej: 1542)">
          <small *ngIf="duplicateTargetOrderErrorMessage" class="text-red-600 text-xs mt-1 block">
            {{ duplicateTargetOrderErrorMessage }}
          </small>
          <small class="text-gray-500 text-xs mt-1 block">
            Si el número no existe, se mostrará una alerta y no se guardará.
          </small>
        </div>
      </div>
    </form>

    <div class="modal-action mt-6 sticky bottom-0 bg-white border-t pt-3 z-10">
      <button class="btn confirm-button" (click)="saveSparePartChanges()" [disabled]="!canSaveForm()"
        [attr.title]="!canSaveForm() ? 'Realice algún cambio para habilitar' : ''">
        {{ duplicateMode ? 'Guardar Repuesto Duplicado' : 'Guardar Cambios' }}
      </button>
      <button class="btn bg-indigo-500 hover:bg-indigo-600 text-white" (click)="requestDuplicate()">Duplicar</button>
      <button *ngIf="!duplicateMode" class="btn bg-red-500 hover:bg-red-600 text-white" (click)="deleteSparePart()">Eliminar Repuesto</button>
      <button class="btn cancel-button" (click)="closeSparePartModal()">Cancelar</button>
    </div>
  </div>
</div>